import { render, staticRenderFns } from "./Comp.vue?vue&type=template&id=6bac073a&scoped=true&"
import script from "./Comp.vue?vue&type=script&lang=js&"
export * from "./Comp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bac073a",
  null
  
)

export default component.exports